module.exports = __webpack_public_path__ + "static/media/dem_vib_con.b26f2685.png";